<!-- Response Summary -->
<div class="row">
  <div class="col-12 mb-3">
    <div>
      <!-- Table -->
      <div>
        <div class="queue-table table-responsive">
          <table class="table table-sm table-borderless">
            <thead>
              <tr>
                <th rowspan="2" class="text-center" width="1%" *ngIf="perResults.testcaseExecSumm?.loadTestType === 'WEB'"></th>
                <th rowspan="2" class="selectedEp" width="12%" (click)="sortByColumn('sequence')" *ngIf="perResults.testcaseExecSumm?.loadTestType === 'WEB'">Selected Endpoints
                    <i *ngIf="columnName ==='sequence' && sortDirection" class="fas fa-arrow-down"></i>
                    <i *ngIf="columnName ==='sequence' && !sortDirection" class="fas fa-arrow-up"></i>
                </th>
                <th rowspan="2" class="text-center selectedEp" width="12%" (click)="sortByColumn('name')" *ngIf="perResults.testcaseExecSumm?.loadTestType !== 'WEB'">Selected Endpoints
                    <i *ngIf="columnName ==='name' && sortDirection" class="fas fa-arrow-down"></i>
                    <i *ngIf="columnName ==='name' && !sortDirection" class="fas fa-arrow-up"></i>
                </th>
                <th colspan="3" class="text-center response-persec" width="7%">Transaction</th>
                <th [attr.colspan]="perResults.testcaseExecSumm?.loadTestType === 'WEB' ? 4 : 5" class="text-center response-persec" width="7%">Response Time(Sec)</th>
                <th rowspan="2" class="text-center selectedEp" width="9%" *ngIf="perResults.testcaseExecSumm?.loadTestType !== 'WEB'" (click)="sortByColumn('hitsPerSecond')">Hits/sec
                    <i *ngIf="columnName ==='hitsPerSecond' && sortDirection" class="fas fa-arrow-down"></i>
                    <i *ngIf="columnName ==='hitsPerSecond' && !sortDirection" class="fas fa-arrow-up"></i>
                </th>
                <th rowspan="2" class="text-center" width="5%" *ngIf="perResults.testcaseExecSumm?.loadTestType !== 'WEB'" (click)="sortByColumn('throughput')">Throughput (Tps)
                    <i *ngIf="columnName ==='throughput' && sortDirection" class="fas fa-arrow-down"></i>
                    <i *ngIf="columnName ==='throughput' && !sortDirection" class="fas fa-arrow-up"></i>
                </th>
                <th colspan="2" class="text-center response-persec" width="7%" *ngIf="perResults.testcaseExecSumm?.loadTestType !== 'WEB'">Network(Kbps)</th>
                <th rowspan="2" class="text-center" width="9%" *ngIf="perResults.testcaseExecSumm?.loadTestType === 'WEB'" (click)="sortByColumn('hitsPerSecond')">
                  {{perResults.testcaseExecSumm?.loadTestType === 'WEB' ? 'Transaction Per Second' : 'Transaction Hits Per Second'}}
                    <i *ngIf="columnName ==='hitsPerSecond' && sortDirection" class="fas fa-arrow-down"></i>
                    <i *ngIf="columnName ==='hitsPerSecond' && !sortDirection" class="fas fa-arrow-up"></i>
                </th>
                <th rowspan="2" class="text-center selectedEp" width="13%" (click)="sortByColumn('status')">Result
                    <i *ngIf="columnName ==='status' && sortDirection" class="fas fa-arrow-down"></i>
                    <i *ngIf="columnName ==='status' && !sortDirection" class="fas fa-arrow-up"></i>
                </th>
              </tr>
              <tr>
                <th class="text-center" width="8%" (click)="sortByColumn('noOfHits')">
                  {{perResults.testcaseExecSumm?.loadTestType === 'WEB' ? 'Total' : 'Total'}}
                    <i *ngIf="columnName ==='noOfHits' && sortDirection" class="fas fa-arrow-down"></i>
                    <i *ngIf="columnName ==='noOfHits' && !sortDirection" class="fas fa-arrow-up"></i>
                </th>
                <th class="text-center" width="8%" (click)="sortByColumn('passedHits')">
                  {{perResults.testcaseExecSumm?.loadTestType === 'WEB' ? 'Passed' : 'Passed'}}
                    <i *ngIf="columnName ==='passedHits' && sortDirection" class="fas fa-arrow-down"></i>
                    <i *ngIf="columnName ==='passedHits' && !sortDirection" class="fas fa-arrow-up"></i>
                </th>
                <th class="text-center" width="5%" (click)="sortByColumn('errorCount')">Failed
                    <i *ngIf="columnName ==='errorCount' && sortDirection" class="fas fa-arrow-down"></i>
                    <i *ngIf="columnName ==='errorCount' && !sortDirection" class="fas fa-arrow-up"></i>
                </th>
                <th class="text-center" width="7%" *ngIf="perResults.testcaseExecSumm?.loadTestType !== 'WEB'" (click)="sortByColumn('actualSla')">Avg.
                    <i *ngIf="columnName ==='actualSla' && sortDirection" class="fas fa-arrow-down"></i>
                    <i *ngIf="columnName ==='actualSla' && !sortDirection" class="fas fa-arrow-up"></i>
                </th>
                <th rowspan="2" class="text-center" width="10%" *ngIf="perResults.testcaseExecSumm?.loadTestType === 'WEB'" (click)="sortByColumn('avgResponse')">Avg.
                    <i *ngIf="columnName ==='avgResponse' && sortDirection" class="fas fa-arrow-down"></i>
                    <i *ngIf="columnName ==='avgResponse' && !sortDirection" class="fas fa-arrow-up"></i>
                </th>
                <th class="text-center" width="5%">
                  <div class="th-content">
                    <div class="small-dropdown-wrapper">
                      <select [(ngModel)]="selectedPercentile" class="small-dropdown">
                        <option *ngFor="let option of selectPercentile" [value]="option.value">
                          {{ option.label }}
                        </option>
                      </select>
                    </div>
                    <i class="fas fa-info-circle text-black" style="cursor: pointer;color:rgb(236, 230, 230)" [ngbPopover]="ninetypercentilepopup" triggers="mouseenter:mouseleave" placement="top">
                    </i>
                  </div>
                  <ng-template #ninetypercentilepopup>
                    <div style="font-size:13px; color:#000;">
                      {{ getSelectedLabel() }} of users response times are better than the given value.
                    </div>
                  </ng-template>
                </th>
                <th class="text-center" width="6%" (click)="sortByColumn('minResponse')">Min
                    <i *ngIf="columnName ==='minResponse' && sortDirection" class="fas fa-arrow-down"></i>
                    <i *ngIf="columnName ==='minResponse' && !sortDirection" class="fas fa-arrow-up"></i>
                </th>
                <th class="text-center" width="6%" (click)="sortByColumn('maxResponse')">Max
                    <i *ngIf="columnName ==='maxResponse' && sortDirection" class="fas fa-arrow-down"></i>
                    <i *ngIf="columnName ==='maxResponse' && !sortDirection" class="fas fa-arrow-up"></i>
                </th>
                <th class="text-center" width="7%" *ngIf="perResults.testcaseExecSumm?.loadTestType !== 'WEB'" (click)="sortByColumn('sla')">Exp.
                    <i *ngIf="columnName ==='sla' && sortDirection" class="fas fa-arrow-down"></i>
                    <i *ngIf="columnName ==='sla' && !sortDirection" class="fas fa-arrow-up"></i>
                </th>
                <th class="text-center" width="7%" *ngIf="perResults.testcaseExecSumm?.loadTestType !== 'WEB'" (click)="sortByColumn('receivedKbPerSecond')">Received
                    <i *ngIf="columnName ==='receivedKbPerSecond' && sortDirection" class="fas fa-arrow-down"></i>
                    <i *ngIf="columnName ==='receivedKbPerSecond' && !sortDirection" class="fas fa-arrow-up"></i>
                </th>
                <th class="text-center" width="7%" *ngIf="perResults.testcaseExecSumm?.loadTestType !== 'WEB'" (click)="sortByColumn('sentKbPerSecond')">Sent
                    <i *ngIf="columnName ==='sentKbPerSecond' && sortDirection" class="fas fa-arrow-down"></i>
                    <i *ngIf="columnName ==='sentKbPerSecond' && !sortDirection" class="fas fa-arrow-up"></i>
                </th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let queueRes of queueRes">
                <tr class="clickable text-center" ngbTooltip="Click for more details" (click)="queueRes.failedSamplesCollapsed = !queueRes.failedSamplesCollapsed" style="background-color: #fff !important">
                  <td class="text-left" *ngIf="perResults.testcaseExecSumm?.loadTestType === 'WEB'">
                    {{queueRes.sequence}}.</td>
                  <td class="text-left wrap">
                    <span triggers="mouseenter:mouseleave" [ngbPopover]="perResults.testcaseExecSumm?.loadTestType !== 'WEB'? EndpointPopContent : null" placement="right">
                      {{queueRes.name}}
                    </span>
                    <ng-template #EndpointPopContent>
                      <div style="font-size:11.5px;color:#000">
                        <div><strong>Think Time :
                          </strong>{{queueRes.loadTestEndPointConfigDto?.think_time ||
                                                    queueRes.loadTestEndPointConfigDto?.think_time === 0 ?
                                                    queueRes.loadTestEndPointConfigDto?.think_time : 'NA'}}
                        </div>
                        <div><strong>Data file Name :
                          </strong>{{queueRes.loadTestEndPointConfigDto?.fileInfo?.fileName
                                                    ? queueRes.loadTestEndPointConfigDto?.fileInfo?.fileName :
                                                    'NA'}}</div>
                      </div>
                    </ng-template>
                  </td>
                  <!-- <td>{{queueRes?.noOfUsers}}</td> -->
                  <td>{{queueRes.noOfHits}}</td>
                  <td>{{queueRes.passedHits}}</td>
                  <td>{{queueRes.errorCount}}</td>
                  <td *ngIf="perResults.testcaseExecSumm?.loadTestType !== 'WEB'">
                    {{queueRes.actualSla}}</td>
                  <td *ngIf="perResults.testcaseExecSumm?.loadTestType === 'WEB'">
                    {{queueRes.avgResponse}}</td>
                  <td>{{queueRes[selectedPercentile] || 'NA'}} <i class="fas fa-info-circle ml-1 text-info" triggers="mouseenter:mouseleave" [ngbPopover]="popContent1"></i>
                  </td>
                  <td>{{queueRes.minResponse || 'NA'}}</td>
                  <td>{{queueRes.maxResponse || 'NA'}}</td>
                  <td *ngIf="perResults.testcaseExecSumm?.loadTestType !== 'WEB'">
                    {{queueRes.sla}}</td>

                  <td>{{queueRes?.hitsPerSecond?.toFixed(2)}}</td>
                  <td *ngIf="perResults.testcaseExecSumm?.loadTestType !== 'WEB'">
                    {{queueRes?.throughput}}</td>
                  <td *ngIf="perResults.testcaseExecSumm?.loadTestType !== 'WEB'">
                    {{queueRes?.receivedKbPerSecond}}</td>
                  <td *ngIf="perResults.testcaseExecSumm?.loadTestType !== 'WEB'">
                    {{queueRes?.sentKbPerSecond}}</td>
                  <td [ngSwitch]="queueRes.status" class="text-center">
                    <div *ngSwitchCase="'PASSED'" class="pass">
                      <img src="/assets/images/performance/completed.png" width="20px" alt="PASSED" ngbTooltip="Passed" placement="bottom">
                    </div>
                    <div *ngSwitchCase="'FAILED'" class="fail">
                      <img src="/assets/images/performance/failed.png" width="20px" alt="FAILED" ngbTooltip="{{(queueRes.actualSla > queueRes.sla) && queueRes.errorCount === 0 ? 'Failed: SLA Breach':'Failed'}}" placement="bottom">
                    </div>
                    <div *ngSwitchCase="'ABORTED'" class="in-review">
                      <img src="/assets/images/performance/abort2.png" width="20px" alt="ABORTED" ngbTooltip="Aborted" placement="bottom">
                    </div>
                    <div class="text-center" *ngSwitchDefault>
                      <img src="/assets/images/spin.svg" width="18">
                    </div>
                  </td>
                  <ng-template #popContent1>
                    <div style="font-size:11.5px;color:#000">
                      <div><strong>50% : </strong>{{queueRes.fiftyPercentile || 'NA'}}
                      </div>
                      <div><strong>80% : </strong>{{queueRes.eightyPercentile || 'NA'}}
                      </div>
                      <div><strong>90% : </strong>{{queueRes.ninetyPercentile || 'NA'}}
                      </div>
                      <div><strong>95% : </strong>{{queueRes.ninetyFivePercentile ||
                                                'NA'}}</div>
                      <div><strong>99% : </strong>{{queueRes.ninetyNinePercentile ||
                                                'NA'}}</div>
                    </div>
                  </ng-template>
                  <ng-template #failedTooltipContent>
                    <div>Failed <span *ngIf="queueRes.errorMessage"> :
                        {{queueRes.errorMessage}}</span></div>
                  </ng-template>
                </tr>
                <tr class="text-center" [ngbCollapse]="!queueRes.failedSamplesCollapsed || queueRes.performanceWebInstructionDtos === null" *ngFor="let webInstruction of queueRes.performanceWebInstructionDtos; let i=index">
                  <td class="text-left">{{i}}.</td>
                  <td class="text-left wrap">{{webInstruction.name}}</td>
                  <td>{{webInstruction.totalHits}}</td>
                  <td>{{webInstruction.passedHits}}</td>
                  <td>{{webInstruction.failedHits}}</td>
                  <td>{{webInstruction.avgResponseTime}}</td>
                  <td>{{webInstruction.ninetyPercentile || 'NA'}} <i class="fas fa-info-circle ml-1 text-info" triggers="mouseenter:mouseleave" [ngbPopover]="popContent2"></i></td>
                  <td>{{webInstruction.minResponseTime}}</td>
                  <td>{{webInstruction.maxResponseTime}}</td>
                  <td>{{webInstruction.hitsPerSecond.toFixed(2)}}</td>
                  <td [ngSwitch]="webInstruction.executionStatus">
                    <div *ngSwitchCase="'PASSED'" class="pass">
                      <img src="/assets/images/performance/completed.png" width="20px" alt="PASSED" ngbTooltip="Passed" placement="bottom">
                    </div>
                    <div *ngSwitchCase="'FAILED'" class="fail">
                      <img src="/assets/images/performance/failed.png" width="20px" alt="FAILED" ngbTooltip="Failed" placement="bottom">
                    </div>
                    <div *ngSwitchCase="'ABORTED'" class="in-review">
                      <img src="/assets/images/performance/abort2.png" width="20px" alt="ABORTED" ngbTooltip="Aborted" placement="bottom">
                    </div>
                    <div class="text-center" *ngSwitchDefault>
                      <img src="/assets/images/spin.svg" width="18">
                    </div>
                  </td>
                  <ng-template #popContent2>
                    <div style="font-size:11.5px;color:#000">
                      <div><strong>50% : </strong>{{webInstruction.fiftyPercentile ||
                                                'NA'}}</div>
                      <div><strong>80% : </strong>{{webInstruction.eightyPercentile ||
                                                'NA'}}</div>
                      <div><strong>90% : </strong>{{webInstruction.ninetyPercentile ||
                                                'NA'}}</div>
                      <div><strong>95% : </strong>{{webInstruction.ninetyFivePercentile ||
                                                'NA'}}</div>
                      <div><strong>99% : </strong>{{webInstruction.ninetyNinePercentile ||
                                                'NA'}}</div>
                    </div>
                  </ng-template>
                </tr>

                <tr [ngbCollapse]="!queueRes.failedSamplesCollapsed">
                  <td colspan="14" *ngIf="!queueRes.failedSamples">
                    <p>No failed records</p>
                  </td>
                  <td colspan="14" *ngIf="queueRes.failedSamples">
                    <div class="row font-bold">
                      <div class="col-1">Count</div>
                      <div class="col-2">Code</div>
                      <div class="col-3">Message</div>
                      <div class="col-6">URL</div>
                    </div>
                    <div class="row" *ngFor="let failedSample of queueRes.failedSamples">
                      <div class="col-1">{{failedSample.count}}</div>
                      <div class="col-2 relay-word-wrap">{{failedSample.code}}</div>
                      <div class="col-3 relay-word-wrap">{{failedSample.message}}</div>
                      <div class="col-6 relay-word-wrap">{{failedSample.url}}</div>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>